module.exports = "/packs/media/images/icons/harborreport_2-eb46a779b4da17508118bca99bfeb6cc.png";